import { ContextWidget } from '../../../types/api/Widget';
import { WidgetType } from '../../../types/api/ElementType';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Icons } from '../../../components/atoms/SVG';
import React from 'react';
import { PendingAccessLevelRequestsBlock } from '../../../_blocks/fib/PendingAccessLevelRequestsBlock';
import { DefaultContextWidget } from '../../_utils/asDefaultWidget';

export type PendingAccessLevelRequestWidget = ContextWidget<
  PendingAccessLevelRequestsBlock,
  WidgetType.pendingAccessLevelRequests
>;

export function PendingAccessLevelRequestWidget({ elementType, ...props }: PendingAccessLevelRequestWidget) {
  const { t } = useSonTranslation('PendingAccessLevelRequests');
  return (
    <DefaultContextWidget
      elementType={elementType}
      icon={Icons.CONTACTS_PHONEBOOK}
      title={t('widgetTitle')}
      {...props}
    ></DefaultContextWidget>
  );
}
